import { render, staticRenderFns } from "./GlossaryButton.vue?vue&type=template&id=6f596537&scoped=true&"
import script from "./GlossaryButton.vue?vue&type=script&lang=js&"
export * from "./GlossaryButton.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryButton.vue?vue&type=style&index=0&id=6f596537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f596537",
  null
  
)

export default component.exports